/**
 * Every catalogue, statically — FOR TESTS AND THE LANGUAGE SWITCH.
 *
 * Unlike the till, the console imports all four eagerly, and that is a
 * considered difference rather than an oversight. The POS lazy-loads because a
 * kilobyte is startup time on a device somebody is standing at with a guest
 * waiting; a back office opens once on a laptop, and four small objects cost
 * less than the flash of an untranslated screen when somebody switches.
 */

import { cs } from "./cs";
import { en } from "./en";
import { sk } from "./sk";
import { uk } from "./uk";

export type { MessageKey, Messages } from "./en";

export const CATALOGS = { cs, en, sk, uk } as const;

export type LocaleName = keyof typeof CATALOGS;

/** In the order a switch should offer them: the market first. */
export const LOCALES: readonly LocaleName[] = ["cs", "en", "sk", "uk"];

export const LOCALE_NAMES: Readonly<Record<LocaleName, string>> = {
  cs: "Čeština",
  en: "English",
  sk: "Slovenčina",
  uk: "Українська",
};

/**
 * Czech unless the browser clearly prefers something else we have.
 *
 * `negotiateLocale` on the till does the same thing, and the fallback is the
 * same and for the same reason: an English sentence in front of a Czech server
 * is worse than a missing string.
 */
export function negotiate(preferred: readonly string[]): LocaleName {
  for (const tag of preferred) {
    const base = tag.toLowerCase().split("-")[0];
    if (base && base in CATALOGS) return base as LocaleName;
  }
  return "cs";
}
